module.exports = __webpack_public_path__ + "img/co-branding-world-RP-background.d86ce09d.png";